<mat-card class="flex-wrapper fix-card">
    <div class="container flex-row center font-large mt-10" style="font-weight: 500;">
        {{ (device$ | async)?.name }}
    </div>
    <div *ngIf="(intervals$|async)===undefined || loading" class="spinner-container">
        <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
    </div>
    <div *ngIf="(intervals$|async)?.length === 0 && !loading" class="spinner-container">
        <div class="container centered-content">
            <div>
                <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
            </div>
            <div>No Data Found</div>
        </div>
    </div>
    <div *ngIf="(intervals$|async)!==undefined && (intervals$|async)?.length !== 0 && !loading">
        <camera-snapshot class="flex-row align-center center" [intervals]="intervals$ | async" [snapType]="snapType" [device]="device$ | async"
            [currentIntervalIndex]="currentIntervalIndex$ | async"  (nextClick)="handleNextClick()"
            (previousClick)="handlePreviousClick()">
        </camera-snapshot>
        <div *ngIf="(currentInterval$ | async)">
            <mat-card-content class="flex-row wrap around card-content-scroll">
                <div class="flex-row justify full-width">
                    <div class="full-width">
                        <card-square-blocks [title]="'Begin'" [warn]="false" [size]="'medium'" [long]="true">
                            {{(currentInterval$ | async).begin | date : dateTimeFormat}}
                        </card-square-blocks>
                    </div>
                    <div class="full-width">
                        <card-square-blocks [title]="'End'" [warn]="false" [size]="'medium'" [long]="true">
                            {{(currentInterval$ | async).end | date : dateTimeFormat}}
                        </card-square-blocks>
                    </div>
                </div>
                <div *ngIf="(device$ | async)?.timelineCustomSizes && (device$ | async)?.timelineCustomSizes.length > 2"
                    class="oversized-rocks-content">
                    <card-square-blocks [title]="'Oversized Rocks'" [warn]="false" [size]="'medium'" [long]="true">
                        {{(currentInterval$ | async).oversizecount}}
                    </card-square-blocks>
                </div>
                <div *ngFor="let key of (percents$ | async).keys(); let j = index">
                    <card-square-blocks [title]="'D' + key" [size]="'medium'" [warn]="false">
                        {{ mapDxxValues((currentInterval$ | async).data).get(key) | unitConversion:  unitSystem}}
                    </card-square-blocks>
                </div>
            </mat-card-content>
        </div>
    </div>
</mat-card>